









































import { Component, Prop, Vue } from "vue-property-decorator";
import { ReportOverview } from "@/models/queries/ReportOverviewQuery";
import { UserService } from "@/services/UserService";
import { ReportStep, DataProgress } from "@/models/graphql-global-types";
import { NewReportStore } from "@/store/NewReportStore";

@Component
export default class ReportButtonBar extends Vue {
  @Prop() report!: ReportOverview;
  @Prop({ default: "end" }) position!: "start" | "end";
  private isDeleting: boolean = false;

  private ReportStep = ReportStep;
  private DataProgress = DataProgress;

  private isUserAdmin = UserService.isUserAdmin;
  private isUserTester = UserService.isUserTester;
  private isUserViewer = UserService.isUserViewer;
  private isUserSupervisor = UserService.isUserSupervisor;

  private shouldShowDeleteIcon() {
    return !UserService.isUserTester() && !UserService.isUserViewer();
  }

  private shouldShowMoveIcon() {
    return (
      (this.report.step === ReportStep.COMPLETED || this.report.step === ReportStep.DONE_GATHERING) &&
      (this.isUserAdmin() || this.isUserSupervisor())
    );
  }

  private shouldShowConfigureIcon() {
    return (
      (this.report.step === ReportStep.IN_PROGRESS || this.report.step === ReportStep.CREATED) &&
      (this.isUserAdmin() || this.isUserSupervisor())
    );
  }

  private shouldShowEditIcon() {
    const step = this.report.step;
    return (
      (step === ReportStep.IN_PROGRESS || step === ReportStep.CREATED || step === ReportStep.DONE_GATHERING) &&
      (this.isUserAdmin() || this.isUserSupervisor() || this.isUserTester())
    );
  }

  private shouldShowMoveOption(reportStep: ReportStep) {
    const reportStepOfReport = this.report.step;
    switch (reportStepOfReport) {
      case ReportStep.CREATED:
        return false;

      case ReportStep.IN_PROGRESS:
        return false;

      case ReportStep.DONE_GATHERING:
        return reportStep === ReportStep.COMPLETED || reportStep === ReportStep.IN_PROGRESS;

      case ReportStep.COMPLETED:
        return reportStep === ReportStep.IN_PROGRESS;

      default:
        return false;
    }
  }

  private moveToLane(lane: ReportStep) {
    if (lane === ReportStep.IN_PROGRESS) {
      NewReportStore.changeStatus({ report: this.report, lane })
        .then(r => {
          NewReportStore.fetchReportOverview();
        })
        .catch(e => console.error(e));
    } else if (lane === ReportStep.COMPLETED) {
      const supervisor = prompt(this.$t("general.supervisor_name") as string, "");

      NewReportStore.completeReport({
        reportId: this.report.id,
        supervisor: supervisor || ""
      });

      if (supervisor && supervisor.length > 0) {
        NewReportStore.completeReport({
          reportId: this.report.id,
          supervisor
        })
          .then(() => NewReportStore.fetchReportOverview())
          .catch(() => {
            this.$notify({
              title: this.$t("general.error.title") as string,
              text: this.$t("general.error.generic_error") as string,
              type: "error"
            });
          });
      }
    }
  }

  public async showConfirmationDialog() {
    const result = await this.$swal({
      title: this.$t("general.confirm") as string,
      html: this.$t("reports_index.dialog.delete_message", {
        report_number: this.report.report_number,
        report_name: this.report.name
      }) as string,
      type: "warning",
      showCancelButton: true,
      cancelButtonText: this.$t("general.cancel") as string,
      confirmButtonText: this.$t("general.delete") as string,
      confirmButtonColor: "#d50032",
      cancelButtonColor: "#c5c8cf",
      focusConfirm: false
    });

    if (result.value) {
      this.isDeleting = true;
      NewReportStore.deleteReport(this.report)
        .then(r => {
          if (r.data.deleteReport === "success") {
            NewReportStore.fetchReportOverview();
          } else {
            alert(r.data.error);
            this.isDeleting = false;
          }
        })
        .catch(e => {
          alert(e);
          this.isDeleting = false;
        });
    }
  }
}
